module.exports = __webpack_public_path__ + "img/folder.b7bfa789.svg";